<template>
  <Modal
    :show="show"
    width="380"
    @close="$emit('close')"
  >
    <template #title>
      Update Job Description
    </template>

    <template #content>
      <p>Choose which fields to include when updating the job description.</p>

      <div class="mt-3">
        <v-checkbox
          :model-value="allSelected"
          :indeterminate="someSelected && !allSelected"
          label="Select all"
          density="compact"
          hide-details
          @update:model-value="toggleAll"
        />
        <v-divider class="my-1" />
        <v-checkbox
          v-for="field in fields"
          :key="field.id"
          v-model="selectedIds"
          :value="field.id"
          :label="field.label"
          density="compact"
          hide-details
        />
      </div>
    </template>

    <template #actions>
      <v-spacer />
      <v-btn
        variant="outlined"
        rounded="lg"
        color="primary"
        :disabled="!someSelected"
        @click="$emit('action', { mode: 'append', selectedFieldIds: selectedIds })"
      >
        Add to existing
      </v-btn>
      <v-btn
        variant="flat"
        rounded="lg"
        color="primary"
        class="ml-2"
        :disabled="!someSelected"
        @click="$emit('action', { mode: 'replace', selectedFieldIds: selectedIds })"
      >
        Replace
      </v-btn>
    </template>
  </Modal>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import Modal from '@/components/shared/Modal.vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  fields: { type: Array, default: () => [] },
});

defineEmits(['close', 'action']);

const selectedIds = ref([]);

watch(() => props.show, (val) => {
  if (val) {
    selectedIds.value = props.fields.map((f) => f.id);
  }
}, { immediate: true });

const allSelected = computed(() => selectedIds.value.length === props.fields.length);
const someSelected = computed(() => selectedIds.value.length > 0);

const toggleAll = (val) => {
  selectedIds.value = val ? props.fields.map((f) => f.id) : [];
};
</script>
